module.exports = __webpack_public_path__ + "static/media/doha.cf67ccf6.jpg";